'use client';
import {FloatingPortal} from '@/components/main/common';
import {FloatingButton} from '@/components/main/MyPlus/FloatingButton';
import BottomBanner from '@/components/main/MyPlus/BottomBanner';
import Confetti from '@/components/main/MyPlus/Confetti';

export const FloatingGroup = ({
  selectedMode,
  handleOnClickMode,
  mainListInfo,
}) => {
  return (
    <>
      {/* 구독 자동결제 가격 인상 동의 레이어 노출기간 동안은 비활성화 */}
      {/* <FloatingPortal
        className={'_Modal_UI_Wrap _set_list'}
        target={'soop_wrap'}>
        <SetList />
      </FloatingPortal> */}
      <FloatingPortal className={'floating_btns'} target={'soop_wrap'}>
        <FloatingButton
          selectedMode={selectedMode}
          handleOnClickMode={handleOnClickMode}
        />
      </FloatingPortal>
      <FloatingPortal target={'soop_wrap'}>
        <BottomBanner mainListInfo={mainListInfo} />
        <Confetti mainListInfo={mainListInfo} />
      </FloatingPortal>
    </>
  );
};
